import SkillItem from "./SkillItem"
import { ISkill, ISkillEnpoints } from '../../../types'

export default class Skill implements ISkill {
  public skillItems: SkillItem[]
  public name: string
  readonly id: number
  readonly endpoints: ISkillEnpoints

  constructor (endpoints: ISkillEnpoints, id: number, name: string, skillItem: SkillItem[]) {
    this.id = id
    this.name = name
    this.skillItems = skillItem
    this.endpoints = endpoints
  }

  public get toParams() {
    const skillItemAttributes = this.skillItems.map((skillItem) => skillItem.toParams)
    return { id: this.id, name: this.name, skill_item_attributes: skillItemAttributes }
  }
}
